import useSWR from 'swr';

import { CollateralHelpers } from 'helpers/CollateralHelpers';
import { CompanyHelpers } from 'helpers/CompanyHelpers';

import { useCompanyProfile } from 'hooks/use-company-profile';
import { CollateralService } from 'services/CollateralService';

// The collateral's own page lives under its company's profile, so the link waits for the company's slug
const useCollateralItem = (collateralId: string) => {
    const { data: collateral, ...swr } = useSWR(CollateralHelpers.swr.item(collateralId), () =>
        CollateralService.get(collateralId),
    );
    const { company } = useCompanyProfile(collateral?.company);

    const href = collateral && company && CompanyHelpers.urls.collateralItem(company.slug ?? company.id, collateral.id);

    return { ...swr, collateral, href };
};

export { useCollateralItem };
